import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";



export const getQuotatinsForDocketCore = (company_id) => {
    return httpClient.get(`${server.QUOTATIONS}/load-quotations-for-docket/${company_id}`);
};
export const getQuotatinsinvoiceListCore = (query) => {
    return httpClient.get(`${server.QUOTATIONS}/invoice-list`, query);
};
export const updateQuotationsCore = (id, data) => {
    return httpClient.put(`${server.QUOTATIONS}/${id}`, data);
};
